import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import {
  clearEndpointErrorLogs,
  subscribeEndpointErrorLogs,
} from "../util/endpointErrorLogs";

// Render any log field safely: objects crash React if rendered as children
// (Minified React error #31), so stringify anything that isn't already text.
function asText(value) {
  if (value == null || value === "") return "-";
  if (typeof value === "object") {
    try {
      return JSON.stringify(value).slice(0, 200);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

function EndpointErrorLogsFooter() {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const unsubscribe = subscribeEndpointErrorLogs((nextLogs) => {
      setLogs(nextLogs);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  if (
    location.pathname.startsWith("/appointments/") ||
    location.pathname === "/post-submit-thank-you" ||
    location.pathname.startsWith("/resume/")
  ) {
    return null;
  }

  return (
    <>
      <div
        className="d-flex justify-content-end align-items-center"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "6px 12px",
          backgroundColor: "rgba(255,255,255,0.95)",
          borderTop: "1px solid #ddd",
          zIndex: 900,
          pointerEvents: "none",
        }}
      >
        <button
          type="button"
          className="btn btn-link p-0"
          style={{
            color: "#c2608e",
            textDecoration: "none",
            pointerEvents: "auto",
          }}
          onClick={() => setShowModal(true)}
          data-cy="btn-view-endpoint-logs"
        >
          Ver logs {logs.length > 0 ? `(${logs.length})` : ""}
        </button>
      </div>

      {showModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div
              className="modal-dialog modal-lg modal-dialog-scrollable"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Endpoint Error Logs</h5>
                  <button
                    type="button"
                    className="close border-0 bg-transparent"
                    onClick={() => setShowModal(false)}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  {logs.length === 0 && (
                    <p className="mb-0">No hay errores registrados.</p>
                  )}
                  {logs.length > 0 && (
                    <div className="table-responsive">
                      <table className="table table-sm table-striped">
                        <thead>
                          <tr>
                            <th>Fecha</th>
                            <th>Metodo</th>
                            <th>Status</th>
                            <th>Contexto</th>
                            <th>Endpoint</th>
                            <th>Mensaje</th>
                          </tr>
                        </thead>
                        <tbody>
                          {logs.map((log) => (
                            <tr key={log.id}>
                              <td>
                                {moment(log.timestamp).format(
                                  "MM/DD/YYYY hh:mm:ss A"
                                )}
                              </td>
                              <td>{asText(log.method)}</td>
                              <td>{asText(log.status)}</td>
                              <td>{asText(log.context)}</td>
                              <td>{asText(log.endpoint)}</td>
                              <td>{asText(log.message)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => clearEndpointErrorLogs()}
                    disabled={logs.length === 0}
                    data-cy="btn-clear-endpoint-logs"
                  >
                    Limpiar logs
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" />
        </>
      )}
    </>
  );
}

export default EndpointErrorLogsFooter;
